<template>
  <div id="main-listado-contrato-actividades">
    <desktop desktop :listado="listado" />
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoContratoActividades',
  components: {
    Desktop,
  },
  props: {
    listado: Array,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
